"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftOrderStatus = exports.ProviderKey = exports.NftStatus = void 0;
var NftStatus;
(function (NftStatus) {
    NftStatus["Available"] = "available";
    NftStatus["Reserved"] = "reserved";
    NftStatus["Confirmed"] = "confirmed";
    NftStatus["Committed"] = "committed";
    NftStatus["Issued"] = "issued";
})(NftStatus || (exports.NftStatus = NftStatus = {}));
var ProviderKey;
(function (ProviderKey) {
    ProviderKey["Stripe"] = "stripe";
    ProviderKey["OpenPayment"] = "open-payment";
})(ProviderKey || (exports.ProviderKey = ProviderKey = {}));
var NftOrderStatus;
(function (NftOrderStatus) {
    NftOrderStatus["PaymentProcessing"] = "PAYMENT_PROCESSING";
    NftOrderStatus["Canceled"] = "CANCELED";
    NftOrderStatus["Completed"] = "COMPLETED";
})(NftOrderStatus || (exports.NftOrderStatus = NftOrderStatus = {}));
//# sourceMappingURL=types.js.map